import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InputComponent } from '@shared/components/input/input.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputComponent],
  selector: 'aux-account-settings',
  styles: [],
  template: `
    <div class="mb-4 text-lg font-bold text-black">Contact Info</div>
    <div class="grid grid-cols-4 gap-10 whitespace-nowrap text-xs">
      <div>
        <div class="mb-3">First Name</div>
        <aux-input [type]="'text'" />
      </div>
      <div>
        <div class="mb-3">Last Name</div>
        <aux-input [type]="'text'" />
      </div>
      <div>
        <div class="mb-3">Title</div>
        <aux-input [type]="'text'" />
      </div>
      <div>
        <div class="mb-3">Company</div>
        <aux-input [type]="'text'" />
      </div>

      <div>
        <div class="mb-3">Email Address</div>
        <aux-input [type]="'email'" />
      </div>

      <div>
        <div class="mb-3">Mobile Phone Number</div>
        <aux-input [type]="'number'" />
      </div>
    </div>

    <div class="my-4 text-lg font-bold text-black">Password</div>
    <div class="grid grid-cols-4 items-end gap-10 whitespace-nowrap text-xs">
      <div>
        <div class="mb-3">Password</div>
        <aux-input [type]="'password'" />
      </div>
      <button class="btn w-40 bg-aux-gray-dark p-3 text-sm">Change Password</button>
    </div>
  `,
})
export class AccountSettingsComponent {}
